function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, open) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'complex-filter': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'complex-filter-display': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              icon: `filter`,
              theme: `tertiary`,
            }),
            "on": {
              click: $helpers.clickedFilterButton
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Filter");
            __jade_nodes = __jade_nodes.concat(h("mp-tag", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'tag-name': $helpers.getSelectedItems().length,
              }),
              "class": {
                'complex-filter-count': true
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            open: open,
          }),
          "on": {
            change: $helpers.handleMenuChange
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              sections: $attr('sections'),
              multiple: true,
            }),
            "on": {
              clickItem: $helpers.handleFilterItemClick
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;